import { PaymentProfile } from '@/types/payment-profile';

export const getDefaultPaymentProfile = (profiles: PaymentProfile[]): PaymentProfile | undefined => {
  if (profiles.length === 1) return profiles[0];
  return profiles.find(profile => profile.defaultProfile);
};
